/*
  Open the main menu's off-site links in a new tab.

  Shopify's menu editor has no "open in new tab" option, so "Buy on Amazon"
  under Cookbooks took the reader off the site in the same tab and their place
  here was gone.

  Narrow on purpose. It marks ONLY the links listed in window.CVC_EXTERNAL_NAV,
  which the footer builds from the main menu itself - so today that is the one
  Amazon item, it follows the URL if Tammy edits that menu item, and it stops
  being marked if she removes it. Nothing else on the page is touched: not the
  footer's social icons, which already set their own target, not the affiliate
  links in the shop grid, and not a link inside a sentence she wrote.

  rel="noopener" because a new tab would otherwise get a handle on this one
  through window.opener; "noreferrer" because an affiliate link does not need
  us to announce which page it came from.
*/
(function () {
  'use strict';

  var WANTED = window.CVC_EXTERNAL_NAV;
  if (!WANTED || !WANTED.length) return;

  function key(href) {
    try { var u = new URL(href, location.href); return u.origin + u.pathname; }
    catch (e) { return href; }
  }
  var want = {};
  WANTED.forEach(function (h) { want[key(h)] = 1; });

  function mark() {
    var links = document.querySelectorAll('.m-header__wrapper a[href], .m-menu-drawer a[href], .cvc-mega a[href]');
    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      if (a.hasAttribute('target')) continue;
      if (!want[key(a.getAttribute('href') || '')]) continue;
      a.setAttribute('target', '_blank');
      var rel = (a.getAttribute('rel') || '').split(/\s+/).filter(Boolean);
      if (rel.indexOf('noopener') === -1) rel.push('noopener');
      if (rel.indexOf('noreferrer') === -1) rel.push('noreferrer');
      a.setAttribute('rel', rel.join(' '));
    }
  }

  function start() {
    mark();
    // The mobile drawer and the mega menu build their markup after load, and
    // the mega menu rebuilds whenever the theme editor re-renders it.
    if (!window.MutationObserver) return;
    var header = document.querySelector('.m-header__wrapper') || document.body;
    new MutationObserver(mark).observe(header, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
